import { Trophy, Sword, Users, BookOpen, Crown }                  from "lucide-react";

// As categorias do ranking agora vem da API (GET /rpg/catalogo: uma por Rei ativo).

export const navLinks = [
  { href: "/",              label: "Home",        icon: Sword },
  { href: "/rules",         label: "Regras",      icon: BookOpen },
  { href: "/rankings",      label: "Rankings",    icon: Trophy },
  { href: "/crews",         label: "Crews",       icon: Users },
  // { href: "/pvptournament", label: "Torneio",     icon: Crown },
];
